import pkceChallenge from "pkce-challenge";
import React from "react";
import ReactDOM from "react-dom";
import Form from "../Form";
import InternalForm from "../InternalForm";
import DOMPurify from 'dompurify';
import { ajax } from "jquery";
import { match } from "assert";
import { ConfigMap, configMap } from "../utils/ConfigMap";

var assert = require("assert");
// Forces local copy of opentoken to be stored in the repository which is against policy
// And seemingly only referenced by an unused function decodeOpenToken
//var token = require("../lib/token");
//const fs = require("fs");
//const path = require("path");
var OpenTokenAPI = require('orx-opentoken').OpenTokenAPI;
var SplunkLogger = require("splunk-logging").Logger;

export type UserAuthorization = {
  userId: string,
  email: string,
  uuid: string,
  accountId: string,
  accountEnvironment: string,
  accountUrl: string,
  accountUser: string,
  // tacked on for reporting
  existsInAuthPass: boolean | null
};


// set up Splunk config 
var config = {
  token: "fc40e6c4-8396-11ec-b81b-005056947d26",
  url: "https://npe-dmz-hec-splunk.optum.com"
};
var Logger = new SplunkLogger(config);

// Enable SSL certificate validation
Logger.requestOptions.strictSSL = true;



export function returnForm() {
  return (
    <div><p>This is the form content</p></div>
  )
}

export function send(payload: any) {
  // TODO: ADD SERVER ORIGIN TO EACH SPLUNK LOG
  // HIGH PRIORITY: SPLUNK ERRORS, SERVER ORIGIN
  // TODO: LOG WHAT DATA CENTER, AND WHAT POD IN THAT DATA CENTER
  var data = JSON.stringify({
    // TODO: HOST TO SERVER POD NAME
    host: process.env.REACT_APP_API_ENV,
    sourcetype: "_json",
    source: "RxClaimWebSignOn",
    event: payload,
  });

  ajax({
    type: 'POST',
    url: "/services/collector/event",
    timeout: 2000,
    headers: {
      Authorization:
        `Splunk ${configMap.splunkClientId}`,
    },
    data: data,
    // making global false will result only the following ajax error being call 
    // and other error handler such as Presto error OpenErrorDialog not trigger
    global: false,
    dataType: "json",
    // function when ajax call return errors
    error: function (request, status, error) {
      // check if the request response returns an error message.
      if (request && request.responseJSON) {
        console.log(request.responseJSON.text + " code: " + request.responseJSON.code);
      } else {
        // log a general response if no response is return.
        console.log("The requested URL was not found on this server");
      }
    }
  });
}

export function loginRedirect(prompt: boolean) {
  // redirect to OHID login after setting code verifier and challenger
  getChallenge();
  var pkceChallengeCodes = getChallenge();
  var verifier = pkceChallengeCodes["code_verifier"];
  sessionStorage.setItem("verifier", verifier);
  var challenger = pkceChallengeCodes["code_challenge"];
  sessionStorage.setItem("challenger", challenger);
  var origin = DOMPurify.sanitize(window.location.origin);
  var test1 = configMap;
  var ohidEndPoint2;
  ohidEndPoint2 = `https://identity.${configMap.ohidBaseUrl}/oidc/authorize?${prompt ? 'prompt=login&' : ''}client_id=rxcl028187N&response_type=code&scope=openid+profile+email+address+phone&redirect_uri=${origin}&code_challenge=${challenger}&code_challenge_method=S256`;
  window.location.href = ohidEndPoint2;
}


function getChallenge() {
  // receive PKCE challenge
  let pkceChallengeCodes: any = window.localStorage.getItem(
    "pkceChallengeCodes"
  );
  if ((!pkceChallengeCodes) || (pkceChallengeCodes === "{}") || (pkceChallengeCodes.length !== 211)) {
    pkceChallengeCodes = pkceChallenge(128);
    window.localStorage.setItem(
      "pkceChallengeCodes",
      JSON.stringify(pkceChallenge(128))
    );
  } else {
    pkceChallengeCodes = JSON.parse(pkceChallengeCodes);
  }
  return pkceChallengeCodes;
}

function findUserAuthByEnv(userAuthorizations: UserAuthorization[] | null, env: string) {
  if (!userAuthorizations) {
    return null;
  }
  const matchingAuths = userAuthorizations.filter(it => { return it.accountEnvironment.toLowerCase().includes(env.toLowerCase()) });
  return (matchingAuths[0]) ?? null;
}

function userAuthIsCompatible(user1: UserAuthorization, user2: UserAuthorization) {
  return (user1.accountUser.toLowerCase() == user2.accountUser.toLocaleLowerCase() && user1.accountId.toLowerCase() == user2.accountId.toLowerCase());
}

export function session(verifier: any, code: string, clientID: any, princeID: any) {
  // API call to OHID after successful OHID login
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  myHeaders.append(
    "Cookie",
    "oidp=ATLVHSeOYHh0iijRFe0JrdAqT2qVGf973W-kjoIFIpnwwCvMyxA-y16-C1BLqA=="
  );
  var origin = window.location.origin;
  var urlencoded = new URLSearchParams();
  urlencoded.append("client_id", clientID);
  urlencoded.append("grant_type", "authorization_code");
  urlencoded.append("redirect_uri", origin);
  urlencoded.append("code", code as any);
  urlencoded.append("code_verifier", verifier);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow" as RequestRedirect,
  };
  var ohidEndPoint = `https://identity.${configMap.ohidBaseUrl}/oidc/token`;

  require('isomorphic-fetch');
  fetch(
    ohidEndPoint,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      // Splunk logging on the OHID token
      // parse through and recieve various tokens
      sessionStorage.setItem("token", result);
      var strID = sessionStorage.getItem("token");
      if (strID != null) {
        var objID = JSON.parse(strID);
        var authT = objID.access_token;
        //sessionStorage.setItem("authToken", authT);
        // decode token to retrieve uuid
        var decoded = decodeID(objID.id_token);
        sessionStorage.setItem("UUID", String(decoded.sub));
        var uuid = String(decoded.sub);
        // Optum Provisioning API call with uuid and auth token
        var splunkOhidToken = {
          message: "User has successful OHID login and token has been generated:",
          ohidToken: result,
          uuid: uuid
        }
        send(JSON.stringify(splunkOhidToken));

        authZUserIdQueryPromise(uuid, authT, princeID)
          .then((authZFoundMatches) => {
            authPassUserIdQueryPromise('ohid', objID.access_token as string)
              .then((authpassFoundMatches) => {
                var authpassMissingAccess = false;
                authpassFoundMatches?.forEach(authPass => {
                  authPass.existsInAuthPass = true;
                });
                var totalAuths = authpassFoundMatches ? [...authpassFoundMatches] : [];
                authZFoundMatches?.forEach(authZ => {
                  const foundEnvInAuthPass = findUserAuthByEnv(authpassFoundMatches, authZ.accountEnvironment);
                  if (!foundEnvInAuthPass) {
                    totalAuths.push(authZ);
                    authpassMissingAccess = true;
                  }
                });
                var splunkTestMatchingAuths = {
                  message: authpassMissingAccess ? "User has missing or mismatching auths in AuthPass" : "User has matching auths in AuthPass and AuthZ",
                  uuid: uuid,
                  authpass: JSON.stringify(authpassFoundMatches),
                  authz: JSON.stringify(authZFoundMatches),
                  finalAuths: JSON.stringify(totalAuths),
                  authpassMissingAccess: authpassMissingAccess,
                };
                send(JSON.stringify(splunkTestMatchingAuths));
                sessionStorage.setItem("auths", JSON.stringify(totalAuths));
                if (!totalAuths) {
                  redirectToChosenAuth(null);
                }
                else {
                  getChosenAuth(totalAuths);
                }
              })
              .catch((error) => console.error('Error in user query:', error));
            return;
          })
          .catch((error) => console.error('Error in authz user query:', error))
      }
    })
    .catch((error) => console.log("error", error));
}

export function getChosenAuth(auths: UserAuthorization[]) {
  if (auths.length < 1) {
    redirectToChosenAuth(null);
  }
  else if (auths.length == 1) {
    redirectToChosenAuth(auths[0]);
  }
  else {
    return ReactDOM.render(
      <React.StrictMode>
        <Form
          auths={auths}
          onUrlChosen={(choice: UserAuthorization) => {
            redirectToChosenAuth(choice);
          }}
        />
      </React.StrictMode>,
      document.getElementById("root")
    );
  }
}

export function redirectToChosenAuth(auth: UserAuthorization | null) {
  if (!auth) {
    console.log("no auth!");
    return;
  }
  if (!auth.accountId || !auth.accountEnvironment || !auth.accountUser) {
    alert(
      "Sorry, you do not have access. Please contact your account manager to provision access. Redirecting to original sign on page now"
    );
    var origin = sessionStorage.getItem("origin");
    // Splunk logging if the user does not have access
    var splunkOpDataNoUpnUrl = {
      // Message can be anything; doesn't have to be an object
      message: "User has accounts in OP but there are no url, upn values associated with those accounts",
      email: auth?.email,
      ohid: auth?.userId,
      uuid: auth?.uuid,
      opdata: JSON.stringify(auth)
    };
    send(JSON.stringify(splunkOpDataNoUpnUrl));
    sessionStorage.clear();
    // redirect to origin page
    window.location.href = `${origin}`;
  }
  else {
    const upn = auth.accountEnvironment + "-" + auth.accountUser;
    var splunkRedirect1 = {
      message: "User has been directed to the RxClaim Web instance for the first time (pre Ping Fed check)",
      url: auth.accountUrl,
      subject: upn,
      uuid: auth.uuid,
      ohid: auth.userId,
      email: auth.email,
      existsInAuthpass: auth.existsInAuthPass
    };
    send(JSON.stringify(splunkRedirect1));

    document.cookie = "kcdtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
    sessionStorage.setItem("upn", upn);
    sessionStorage.setItem("url", auth.accountUrl);
    sessionStorage.setItem('ohid', auth.userId);
    sessionStorage.setItem('email', auth.email);
    //redirect
    window.location.replace("//" + auth.accountUrl);
  }
}

export function decodeID(token: any) {
  // decode auth token to get uuid
  if (token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  } else {
    return null;
  }
}

export function getCookie(name: any) {
  function escape(s: any) {
    return s.replace(/([.*+?$(){}|\]\\])/g, "\\$1");
  }
  var match = document.cookie.match(
    RegExp("(?:^|;\\s*)" + escape(name) + "=([^;]*)")
  );
  return match ? match[1] : null;
}

// Seemingly unused function linked with imported token variable
// export function decodeOpenToken(opentoken: any) {
//   token.decode(opentoken);
// }

export function postPingFed(sessionId: any, pass: any) {
  // sessionID from decoded resume variable
  var sessionID = sessionId;
  if (document.cookie.match(/kcdtoken/) !== null) {
    // if cookie is already there, then clear
    console.log("cookie is already there")
    document.cookie = "kcdtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
  }

  // create opentokenapi instance
  var cipherId = 1;
  //obfuscated password
  var password = pass;
  var otkOptions = {};
  var otkapi = new OpenTokenAPI(cipherId, password, otkOptions);
  var user_uuid: any = sessionStorage.getItem("UUID");
  var user_email = sessionStorage.getItem("email");
  var user_ohid = sessionStorage.getItem("ohid");
  var user_upn = sessionStorage.getItem("upn");
  var user_url = sessionStorage.getItem("url");
  var userData = {
    subject: user_upn,
    email: user_email,
    ohid: user_ohid,
    uuid: user_uuid,
    url: user_url,
  };

  if (userData.subject == null) {
    console.log("Open token is null, redirecting");
    window.location.replace(origin);
    return null;
  }

  otkapi.createToken(userData, function (err: any, result: any) {
    console.log("creating open token....");
    console.log("Test OpenTokenAPI::createToken... ");
    assert.ifError(err);
    console.log("OK\n");

    var opentoken = sessionStorage.getItem("opentoken");

    // initiate post request to pingfederate
    if (opentoken !== null) {
      // Splunk logging when the open token is created
      var uuid = sessionStorage.getItem("UUID");
      var ohid = sessionStorage.getItem("ohid");
      var email = sessionStorage.getItem("email");
      var upn = sessionStorage.getItem("upn");
      var url = sessionStorage.getItem("url");
      var splunkOpenToken = {
        message: "Open Token has been created for the user with OHID, sending to Ping Fed now.",
        otk: opentoken,
        subject: upn,
        url: url,
        uuid: uuid,
        ohid: ohid,
        email: email
      }
      send(JSON.stringify(splunkOpenToken));

      otkapi.parseToken(opentoken, function (err: any, result: any) {
        console.log("PARSING");
      });
      postOpenToken(opentoken, sessionID, user_url);
    }
  });
}

export function postOpenToken(opentoken: any, sessionId: any, url: any) {
  //check to make sure kcdtoken not already in cookies 

  if (document.cookie.match(/kcdtoken/) !== null) {
    // if cookie is already there, then clear
    console.log("cookie is already there")
    document.cookie = "kcdtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
  }
  document.cookie = `kcdtoken=${opentoken};domain=.optum.com;SameSite=Strict`;

  var myHeaders = new Headers();
  myHeaders.append("Cookie", `kcdtoken=${opentoken};domain=.optum.com;SameSite=Strict`);
  myHeaders.append("Access-Control-Allow-Origin", "*");

  var requestOptions = {
    method: "POST",
    credentials: "include" as RequestCredentials,
    mode: "no-cors" as RequestMode,
    headers: myHeaders,
    redirect: "follow" as RequestRedirect,
  };
  var pingEndPoint = `https://${configMap.pingBaseUrl}/as/${sessionId}/resume/as/authorization.ping`;;
  require('isomorphic-fetch');
  fetch(
    pingEndPoint,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      window.location.replace("//" + encodeURI(url));
    })
    .catch((error) => console.log("error", error));
}

//
//
//START OF THE MSID PATH - INTERNAL USERS
//
//

export function msidRedirect() {
  getChallenge();
  var pkceChallengeCodes = getChallenge();
  var verifier = pkceChallengeCodes["code_verifier"];
  sessionStorage.setItem("msidVerifier", verifier);
  var challenger = pkceChallengeCodes["code_challenge"];
  sessionStorage.setItem("msidChallenger", challenger);
  var origin = DOMPurify.sanitize(window.location.origin);
  var msidEndPoint2 = `https://${configMap.azureBaseUrl}/db05faca-c82a-4b9d-b9c5-0f64b6755421/oauth2/v2.0/authorize?client_id=${configMap.azureClientId}&response_type=code&redirect_uri=${origin}&scope=openid&code_challenge=${challenger}&code_challenge_method=S256&x-idp=azuread`;
  window.location.href = msidEndPoint2;
}

export function msidToken(verifier: any, code: string, clientID: any) {
  // API call to azure after successful MSID login
  var origin = window.location.origin;
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  myHeaders.append("origin", origin);
  var urlencoded = new URLSearchParams();
  urlencoded.append("client_id", clientID);
  urlencoded.append("grant_type", "authorization_code");
  urlencoded.append("redirect_uri", origin);
  urlencoded.append("code", code as any);
  urlencoded.append("code_verifier", verifier);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow" as RequestRedirect,
  };
  var msidEndPoint = `https://${configMap.azureBaseUrl}/db05faca-c82a-4b9d-b9c5-0f64b6755421/oauth2/v2.0/token`;

  require('isomorphic-fetch');
  fetch(
    msidEndPoint,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      console.log(result);
      // parse through and recieve various tokens
      sessionStorage.setItem("msidToken", result);
      var msidResponse = sessionStorage.getItem("msidToken");
      if (msidResponse != null) {
        // change MSID response to readable format
        var msidID = JSON.parse(msidResponse);
        var msidAuthT = msidID.access_token;

        //decode access_token to get display name 
        var accessDecoded = decodeID(msidAuthT);
        var displayName = accessDecoded.given_name;
        //console.log(displayName);
        sessionStorage.setItem("firstName", displayName);

        // decode ID token to retrieve uuid
        var msidDecoded = decodeID(msidID.id_token);
        var msidEmployeeId = String(msidDecoded.employeeID);
        var msidSAMA = String(msidDecoded.sAMAccountName);

        //set to session storage
        //sessionStorage.setItem("msidEmployee", msidEmployeeId);
        sessionStorage.setItem("sAMAccountName", msidSAMA);

        var msidAuthDecoded = decodeID(msidAuthT);
        sessionStorage.setItem("msidAuthT", String(msidAuthDecoded));
        //var msidAuthTDName = String(msidAuthDecoded.unique_name);
        var msidAuthTDUpn = String(msidAuthDecoded.upn);

        sessionStorage.setItem("msid", msidSAMA);
        //sessionStorage.setItem("msidUuid", msidEmployeeId);
        sessionStorage.setItem("msidEmail", String(msidAuthTDUpn));

        var splunkMsidToken = {
          message: "User has successful MSID login and token has been generated:",
          msidToken: msidID.access_token,
          msid: msidSAMA,
          //employeeId: msidEmployeeId,
          email: String(msidAuthTDUpn)
        }
        send(JSON.stringify(splunkMsidToken));

        retrieveAdLookup(msidEmployeeId, msidID.access_token);
      }
    })
    .catch((error) => console.log("error", error));
}

export function retrieveAdLookup(empId: any, access_token: any) {


  // @ts-ignore
  //const env = window['environments'];
  //console.log(env);
  let url = `https://${configMap.gatewayBaseUrl}/rxclaim-web-backend-service/v1/ad-lookup-service/getAdLookup?employeeId=${empId}`;

  return fetch(url, {
    method: "GET",
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${access_token}`
    })
  })
    .then((res: any) => res.json())
    .then((data) => {
      //console.log("GOT TO BACKEND");
      //console.log(data);

      if (data.errorMsg !== null || data.samAccount == null) {
        alert("Your Employee ID has not been provisioned for access. Please contact your account manager.")
        window.location.replace(window.location.origin);
      }

      // split account values and sort/reverse to put the empty value at the end
      var samAccounts: any = data.samAccount.split(',');
      samAccounts.sort();
      samAccounts.reverse();
      //console.log(samAccounts);

      var envAccMap = new Map();
      var i = 0;
      var curEnv = "";
      var curAcc = "";
      var allEnvs = [];
      //map environments to access
      // while(i<samAccounts.length-1){
      //   // check if its a new environment
      //   curEnv = samAccounts[i].split('-')[0];
      //   curAcc = samAccounts[i].split('-')[1];
      //   if(envAccMap.has(curEnv)){
      //     // same environment
      //     envAccMap.set(curEnv, envAccMap.get(curEnv).push(curAcc));
      //   }else{
      //     // new environment
      //     allEnvs.push(curEnv);
      //     var accounts:any = [curAcc];
      //     envAccMap.set(curEnv, accounts);
      //   }
      //   i++;
      // }

      //console.log(envAccMap);
      // var mapStr = JSON.stringify(Array.from(envAccMap.entries()));
      // //console.log(mapStr);
      // sessionStorage.setItem("mappedValsStr", mapStr);

      var splunkMsidVals = {
        message: "User's RXCLAD Provisioning data:",
        msid: sessionStorage.getItem("msid"),
        //employeeId: sessionStorage.getItem("msidUuid"),
        email: sessionStorage.getItem("msidEmail"),
        value: samAccounts
      }
      send(JSON.stringify(splunkMsidVals));

      //check all access to only bring up form if user profiles are greater than one

      // have users choose from dropdown, looking at env name. Then route to linked url

      samAccounts.pop();
      console.log("number of accounts" + samAccounts.length);
      if (samAccounts.length > 1) {
        return ReactDOM.render(
          <React.StrictMode>
            <InternalForm acc={samAccounts} />
          </React.StrictMode>,
          document.getElementById("root")
        );
      }
      // user only has 1 profile - select first entry and proceed

      else if (samAccounts.length == 1) {
        formContinued(samAccounts[0]);
      } else {
        // user is set up in splunk but has no environments set up
        var splunkLdapAccountError = {
          message: "User is set up in LDAP but has no accounts set:",
          employeeId: empId,
        }
        send(JSON.stringify(splunkLdapAccountError));
      }

    })
    .catch(error => {
      console.log('Backend call error', error);
      var splunkLdapError = {
        message: "User has had a backend call error during LDAP connection:",
        employeeId: empId,
        error: error
      }
      send(JSON.stringify(splunkLdapError));
    });
}


export function formContinued(selectedVal: any) {

  console.log("Selected Value:" + selectedVal);
  sessionStorage.setItem("upn_msid", selectedVal);
  var curEnv = selectedVal.split('-')[0];
  var curAcc = selectedVal.split('-')[1];


  //const [openModal, setOpenModal] = React.useState(false);
  //const handleClose = () => {
  //  console.log("handleClose");
  //  setOpenModal(false);
  //}


  console.log(curEnv);
  console.log(curAcc);


  sessionStorage.setItem("envSelected", curEnv);
  sessionStorage.setItem("accSelected", curAcc);


  var first: any = sessionStorage.getItem('firstName');


  // create environment to url map and grab url when user hits submit
  var urlLinks = new Map();
  var url = "";
  if (process.env.REACT_APP_API_ENV === 'stg') {
    // stage link setup
    urlLinks.set("rxcl1tst", "rxclaim-uat.optum.com");
    urlLinks.set("rxcl3tst", "rxclaim-uat3.optum.com");
    urlLinks.set("rxbk1uat", "rxclaim-uat1.optum.com");
    urlLinks.set("rxbk2uat", "rxclaim-uat2.optum.com");
    urlLinks.set("rxt1tst", "rxclaim-tst.optum.com");
    urlLinks.set("rxbk1pt", "rxclaim-pt.optum.com");
    urlLinks.set("rxdv1", "rxclaim-qa.optum.com");
    urlLinks.set("rxbk1qa", "rxclaim-qa1.optum.com");
    urlLinks.set("rxbk2qa", "rxclaim-qa2.optum.com");
    urlLinks.set("rxmcmqa", "rxclaim-mcmqa.optum.com");
    urlLinks.set("rxmcmuat", "rxclaim-mcmuat.optum.com");
    urlLinks.set("rxbchuat", "rxclaim-bchuat.optum.com");
    urlLinks.set("rxfc6tst", "rxclaim-ofe-stg.optum.com");
  } else {
    // prod link
    urlLinks.set("rxbk1", "rxclaim-bk1.optum.com");
    urlLinks.set("rxbk2", "rxclaim-bk2.optum.com");
    urlLinks.set("rxcl1", "rxclaim-cl1.optum.com");
    urlLinks.set("rxcl2", "rxclaim-cl2.optum.com");
    urlLinks.set("rxcl3", "rxclaim-cl3.optum.com");
    urlLinks.set("rxcl4", "rxclaim-cl4.optum.com");
    urlLinks.set("rxcl5", "rxclaim-cl5.optum.com");
    urlLinks.set("rxcnp", "rxclaim-cnp.optum.com");
    urlLinks.set("rxmcm", "rxclaim-mcm.optum.com");
    urlLinks.set("rxbch", "rxclaim-bch.optum.com");
    urlLinks.set("rxfc6", "rxclaim-ofe-fc6.optum.com");
  }
  // redirect to selected link
  var selectedEnv = sessionStorage.getItem("envSelected");
  url = urlLinks.get(selectedEnv);

  console.log(url);

  var splunkMsidAcc = {
    message: "User has been directed to the RxClaim Web instance for the first time (pre Ping Fed check)",
    msid: sessionStorage.getItem("msid"),
    //employeeId: sessionStorage.getItem("msidUuid"),
    email: sessionStorage.getItem("msidEmail"),
    url: url,
    subject: sessionStorage.getItem("upn_msid")
  }
  send(JSON.stringify(splunkMsidAcc));


  sessionStorage.setItem("selectedUrl", url);
  window.location.replace("//" + url);
}

export function msidPostPingFed(sessionId: any, pass: any) {
  // sessionID from decoded resume variable
  var sessionID = sessionId;
  if (document.cookie.match(/kcdtoken/) !== null) {
    // if cookie is already there, then clear
    console.log("cookie is already there")
    document.cookie = "kcdtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
    //add splunk
  }
  // create opentokenapi instance
  var cipherId = 1;
  //obfuscated password
  var password = pass;
  var otkOptions = {};
  var otkapi = new OpenTokenAPI(cipherId, password, otkOptions);
  var msid_uuid: any = sessionStorage.getItem("msidUuid");
  var msid_email = sessionStorage.getItem("msidEmail");
  var msid = sessionStorage.getItem("msid");
  var msid_upn = sessionStorage.getItem("upn_msid");
  var msid_url = sessionStorage.getItem("selectedUrl");

  var userData = {
    subject: msid_upn,
    email: msid_email,
    ohid: msid,
    uuid: msid_uuid,
    url: msid_url,
  };
  if (userData.subject == null) {
    console.log("Open token is null, redirecting");
    window.location.replace(origin);
    return null;
  }

  otkapi.createToken(userData, function (err: any, result: any) {
    console.log("creating open token....");
    console.log("Test OpenTokenAPI::createToken... ");
    assert.ifError(err);
    console.log("OK\n");
    var opentoken = sessionStorage.getItem("opentoken");

    // initiate post request to pingfederate
    if (opentoken !== null) {
      // Splunk logging when the open token is created
      var uuid = sessionStorage.getItem("msidUuid");
      var msid = sessionStorage.getItem("msid");
      var email = sessionStorage.getItem("msidEmail");
      var upn = sessionStorage.getItem("envSelected") + "-" + sessionStorage.getItem("accSelected");
      var url = sessionStorage.getItem("selectedUrl");

      var splunkOpenToken = {
        message: "Open Token has been created for the user with MSID, sending to Ping Fed now.",
        otk: opentoken,
        subject: upn,
        url: url,
        //employeeId: uuid,
        msid: msid,
        email: email
      }
      send(JSON.stringify(splunkOpenToken));

      otkapi.parseToken(opentoken, function (err: any, result: any) {
        console.log("PARSING");
      });
      msidPostOpenToken(opentoken, sessionID, msid_url);
    }
  });
}

export function msidPostOpenToken(opentoken: any, sessionId: any, url: any) {
  //check to make sure kcdtoken not already in cookies 
  if (document.cookie.match(/kcdtoken/) !== null) {
    // if cookie is already there, then clear
    console.log("cookie is already there")
    document.cookie = "kcdtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
  }
  document.cookie = `kcdtoken=${opentoken};domain=.optum.com;SameSite=Strict`;

  var myHeaders = new Headers();
  myHeaders.append("Cookie", `kcdtoken=${opentoken};domain=.optum.com;SameSite=Strict`);
  myHeaders.append("Access-Control-Allow-Origin", "*");

  var requestOptions = {
    method: "POST",
    credentials: "include" as RequestCredentials,
    mode: "no-cors" as RequestMode,
    headers: myHeaders,
    redirect: "follow" as RequestRedirect,
  };
  var pingEndPoint = `https://${configMap.pingBaseUrl}/as/${sessionId}/resume/as/authorization.ping`;
  require('isomorphic-fetch');
  fetch(
    pingEndPoint,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      window.location.replace("//" + url);
    })
    .catch((error) => {
      var uuid = sessionStorage.getItem("msidUuid");
      var msid = sessionStorage.getItem("msid");
      var email = sessionStorage.getItem("msidEmail");
      var upn = sessionStorage.getItem("envSelected") + "-" + sessionStorage.getItem("accSelected");
      var url = sessionStorage.getItem("selectedUrl");
      console.log("error", error)
      var splunkPingError = {
        message: "User has had an unsuccessful Ping authentication:",
        otk: opentoken,
        subject: upn,
        url: url,
        uuid: uuid,
        ohid: msid,
        email: email
      }
      send(JSON.stringify(splunkPingError));
    });
}

//
//
//START OF THE GovID PATH - INTERNAL USERS
//
//
export function govIdRedirect(prompt: boolean) {
  // redirect to GovID login after setting code verifier and challenger
  getChallenge();
  var pkceChallengeCodes = getChallenge();
  var govIdverifier = pkceChallengeCodes["code_verifier"];
  sessionStorage.setItem("govIdVerifier", govIdverifier);
  var challenger = pkceChallengeCodes["code_challenge"];
  sessionStorage.setItem("govIdchallenger", challenger);
  var origin = DOMPurify.sanitize(window.location.origin);
  var govIdEndPoint2 = `https://identity.${configMap.govIdBaseUrl}/oidc/authorize?${prompt ? 'prompt=login&' : ''}client_id=${configMap.govIdOauthClientId}&response_type=code&scope=openid+profile+email+address+phone&redirect_uri=${origin}&code_challenge=${challenger}&code_challenge_method=S256`;

  window.location.href = govIdEndPoint2;

}

export function govIdSession(govIdverifier: any, code: string, clientID: any, princeID: any) {
  // API call to GovId after successful GovId login

  var govIdEndPoint = `https://identity.${configMap.govIdBaseUrl}/oidc/token`;
  var clientId = configMap.govIdOauthClientId;

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  myHeaders.append(
    "Cookie",
    "oidp=ATEyPTg4XmSqXTHzCTHPvIfod7bxfYZzNIZioEfteVgezajVxIC6hOIratZ_WA=="
  );
  myHeaders.append("user-agent", clientId);
  var origin = window.location.origin;
  var urlencoded = new URLSearchParams();
  urlencoded.append("client_id", clientId);
  urlencoded.append("grant_type", "authorization_code");
  urlencoded.append("redirect_uri", origin);
  urlencoded.append("code", code as any);
  urlencoded.append("code_verifier", govIdverifier);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow" as RequestRedirect,
  };

  require('isomorphic-fetch');
  fetch(
    govIdEndPoint,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      var resultText = JSON.stringify(result)
      var accessToken = result.access_token
      // Splunk logging on the GovId token
      // parse through and recieve various tokens
      sessionStorage.setItem("token", resultText);
      var strID = sessionStorage.getItem("token");
      if (strID != null) {
        var objID = JSON.parse(strID);
        var authT = objID.access_token;
        //sessionStorage.setItem("authToken", authT);
        // decode token to retrieve uuid
        var decoded = decodeID(objID.id_token);
        sessionStorage.setItem("UUID", String(decoded.sub));
        var uuid = String(decoded.sub);
        sessionStorage.setItem("userName", String(decoded.preferred_username));
        var userName = String(decoded.preferred_username);
        sessionStorage.setItem("email", String(decoded.email));
        var email = String(decoded.email);

        // Optum Provisioning API call with uuid and auth token
        var splunkGovidToken = {
          message: "User has successful GovID login and token has been generated:",
          govIdToken: resultText,
          uuid: uuid,
          username: userName,
          email: email,
        }
        send(JSON.stringify(splunkGovidToken));
        // Retrieve URL and UPN with Promise equiv to opQuery
        authPassUserIdQueryPromise('govid', accessToken)
          .then((matchFound) => {
            // govid should only have 1 match ?
            if (matchFound && matchFound[0].accountUrl) {
              const upn = matchFound[0].accountId + "-" + matchFound[0].accountUser;
              console.log("Matched! URL:", matchFound[0].accountUrl, ", UPN:", upn);
              // Do whatever you want here with matchFound.url & matchFound.upn:
              // For example:
              //window.location.replace("//" + matchFound.url);
              sessionStorage.setItem("urlNameVal", matchFound[0].accountUrl);
              sessionStorage.setItem("upnNameVal", upn);

              govIdCont(matchFound[0].accountUrl);
            } else {
              console.log("No match found!");
              alert(
                "Sorry, you do not have access. Please contact your account manager to provision access. Redirecting to original sign on page now"
              );
              var origin = sessionStorage.getItem("origin");
              if (origin != null) {
                window.location.href = origin;
              }
              // Fallback: main url site without any parameters
              else {
                window.location.href = window.location.toString().replace(window.location.search, "");
              }
              // Splunk logging if the user does not have access
              var splunkOpDataNoUpnUrl = {
                // Message can be anything; doesn't have to be an object
                message: "User has accounts in OP but there are no url, upn values associated with those accounts",
                //ohid: ohid,
                uuid: uuid,
                opdata: result
              };
            }
          })
          .catch((error) => console.error('Error in user query:', error));

        console.log("UUID", uuid);
      }
    })
    .catch((error) => console.log("error", error));
}


function authPassUserIdQueryPromise(type: string, token: string): Promise<UserAuthorization[] | null> {
  return new Promise((resolve, reject) => {
    authPassUserIdQuery(type, token, resolve, reject); // resolve will be called with MatchedRow or null
  });
}

// This mounts the React Parent component for searching by UUID.
// onResult will be called with {url, upn} or null.
export function authPassUserIdQuery(
  type: string,
  token: string,
  onResult: (matchFound: UserAuthorization[] | null) => void,
  onReject: (error: any) => void
) {
  let url = `https://${configMap.baseUrl}/api/authorization/${type}`;

  fetch(url, {
    method: "GET",
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
  })
    .then((res: any) => res.json())
    .then((data) => {
      onResult(data);
    })
    .catch((error) => {
      console.log("authpass user data error", error);
      onResult(null);
    });
}

function authZUserIdQueryPromise(uuid: string, auth: string, princeID: string): Promise<UserAuthorization[] | null> {
  return new Promise((resolve, reject) => {
    authZUserIdQuery(uuid, auth, princeID, resolve, reject); // resolve will be called with MatchedRow or null
  });
}

export function authZUserIdQuery(uuid: string, auth: string, princeID: string, onResult: (matchFound: UserAuthorization[] | null) => void, onReject: (error: any) => void) {
  // build out API call to Optum Provisioning
  // after OHID login and OHID API call
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + auth);
  myHeaders.append("X-PrincipalID-Type", "uuid");
  myHeaders.append("X-PrincipalID", princeID);
  myHeaders.append("X-CorrelationID", "1234");
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append(
    "Cookie",
    "BIGipServerapps.ocp-ctc-dmz-stg.optum.com_80=3058718218.20480.0000; TS01141950=013ee936b42d02b8238327c2be5d941322cb014f1cfd2926a68bcac6eadd4f98a3b3bdce1fae4f83a4d2fcbd16787f1b4f1bd03d23; TS01675af7=013ee936b49ae684aaf907f81de50d31c4c115d1876a25660fa97bdda210be4478af89477e0ec2206fe1b3ebf6b710ba578a8e93d2; c3a461391a176da6951f6e68039fa03a=bd4ade1279253d20f04e80e8f19c350d"
  );

  var raw = JSON.stringify({
    userID: {
      idType: "uuid",
      id: uuid,
    },
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow" as RequestRedirect,
  };
  var opEndPoint = `https://api.${configMap.ohidBaseUrl}/api/v1.1/authorization/user?op=get`;
  require('isomorphic-fetch');
  fetch(
    opEndPoint,
    requestOptions
  )
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.status === "SUCCESS") {
        const email = responseJson.user.contact.registeredEmail;
        var userName: string | null = null;
        sessionStorage.setItem("email", email);
        var foundUserAuths: UserAuthorization[] = [];
        var foundUserIdentifiers = new Map();
        var accounts = responseJson.user.accounts;
        for (var i = 0; i < accounts.length; i++) {
          const userIdentifiers = accounts[i].organizations[0].services[0].userDetails.userIdentifiers;
          userIdentifiers.forEach((identifier: any) => {
            if (identifier.name.includes("Optum ID")) {
              userName = identifier.value as string;
            }
            else {
              const splitName = identifier.name.split('_');
              const env = splitName[1];
              const key = splitName[2];
              if (!foundUserIdentifiers.has(env)) {
                foundUserIdentifiers.set(env, {});
              }
              const foundIdentifier = foundUserIdentifiers.get(env);
              if (key == 'url') {
                foundUserIdentifiers.get(env).url = identifier.value;
              }
              else if (key == 'upn') {
                foundUserIdentifiers.get(env).upn = identifier.value;
              }
            }
          });
          if (userName && email) {
            foundUserIdentifiers.forEach((value, key) => {
              if (value.url && value.upn) {
                const upnComponents = value.upn.split('-');
                foundUserAuths.push({
                  userId: userName as string,
                  email: email,
                  uuid: uuid,
                  accountId: upnComponents[0],
                  accountEnvironment: upnComponents[0],
                  accountUrl: value.url,
                  accountUser: upnComponents[1],
                  existsInAuthPass: false
                })
              }
            });
            onResult(foundUserAuths);
          }
          else {
            onResult(null);
          }
        }
      } else {
        onResult(null);
        //onReject(null);
      }
    })
    .catch((error) => {
      console.log("error", error);
      onResult(null);
    });
}

export function govIdCont(url: any) {
  var urlValChosen = url;
  var urlNameVal: any = sessionStorage.getItem("urlNameVal");
  var upnNameVal: any = sessionStorage.getItem("upnNameVal");
  var firstNameVal: any = sessionStorage.getItem("firstNameVal");
  var lastNameVal: any = sessionStorage.getItem("lastNameVal");
  var emailVal: any = sessionStorage.getItem("emailVal");
  /*
  urlNameVal = urlNameVal.split(",");
  upnNameVal = upnNameVal.split(",");
  var urlNameValReal:any = [];
  var upnNameValReal:any = [];
  for(var i=0;i<urlNameVal.length;i=i+2){
    if(urlNameVal[i] === undefined){
      break;
    }
    urlNameValReal.push([urlNameVal[i],urlNameVal[i+1]]);
    upnNameValReal.push([upnNameVal[i],upnNameVal[i+1]]);
  }
  var urlNameChosen;
  for(i=0;i<urlNameValReal.length;i++){
    if(urlNameVal[i] === undefined){
      break;
    }
    if(urlNameValReal[i][1] === urlValChosen){
      urlNameChosen = urlNameValReal[i][0];
    }
  }
  var splitNameVals = urlNameChosen.split("_");
  var connector = splitNameVals[1];
  var upnEquivalent;
  for(i=0; i<upnNameValReal.length;i++){
    if(urlNameVal[i] === undefined){
      break;
    }
    if(upnNameValReal[i][0].includes(connector)){
      upnEquivalent = upnNameValReal[i][1];
    }
  }
    */
  // Splunk logging on what the user chooses
  var uuid = sessionStorage.getItem("UUID");
  //var govId = sessionStorage.getItem("govId");
  var email = sessionStorage.getItem("email");
  var userName = sessionStorage.getItem("userName");
  var splunkRedirect1 = {
    message: "User has been directed to the RxClaim Web instance for the first time (pre Ping Fed check)",
    url: urlValChosen,
    //subject: upnEquivalent,
    uuid: uuid,
    username: userName,
    email: email
  };
  send(JSON.stringify(splunkRedirect1));

  document.cookie = "kcdtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
  sessionStorage.setItem("upn", upnNameVal);
  sessionStorage.setItem("url", urlValChosen);
  window.location.replace("//" + encodeURI(urlValChosen));
}

export function govIdPostPingFed(sessionId: any, pass: any) {
  // sessionID from decoded resume variable
  var sessionID = sessionId;
  if (document.cookie.match(/kcdtoken/) !== null) {
    // if cookie is already there, then clear
    console.log("cookie is already there")
    document.cookie = "kcdtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
  }

  // create opentokenapi instance
  var cipherId = 1;
  //obfuscated password
  var password = pass;
  var otkOptions = {};
  var otkapi = new OpenTokenAPI(cipherId, password, otkOptions);
  var user_uuid: any = sessionStorage.getItem("UUID");
  var user_email = sessionStorage.getItem("email");
  var user_govId = sessionStorage.getItem("userName");
  var user_upn = sessionStorage.getItem("upn");
  var user_url = sessionStorage.getItem("url");
  var user_first = sessionStorage.getItem("first");
  var user_last = sessionStorage.getItem("last");
  var user_email = sessionStorage.getItem("email");
  var userData = {
    subject: user_upn,
    email: user_email,
    ohid: user_govId,
    uuid: user_uuid,
    url: user_url,
  };

  if (userData.subject == null) {
    console.log("Open token is null, redirecting");
    window.location.replace(origin);
    return null;
  }
  otkapi.createToken(userData, function (err: any, result: any) {
    console.log("creating open token....");
    console.log("Test OpenTokenAPI::createToken... ");
    assert.ifError(err);
    console.log("OK\n");

    var opentoken = sessionStorage.getItem("opentoken");

    // initiate post request to pingfederate
    if (opentoken !== null) {
      // Splunk logging when the open token is created
      var uuid = sessionStorage.getItem("UUID");
      //var govId = sessionStorage.getItem("govId");
      var email = sessionStorage.getItem("email");
      var upn = sessionStorage.getItem("upn");
      var url = sessionStorage.getItem("url");

      var splunkOpenToken = {
        message: "Open Token has been created for the user with GOVID, sending to Ping Fed now.",
        otk: opentoken,
        subject: upn,
        url: url,
        uuid: uuid,
        email: email,
      }
      send(JSON.stringify(splunkOpenToken));

      otkapi.parseToken(opentoken, function (err: any, result: any) {
        console.log("PARSING");
      });
      govIdPostOpenToken(opentoken, sessionID, user_url);
    }
  });
}

export function govIdPostOpenToken(opentoken: any, sessionId: any, url: any) {
  //check to make sure kcdtoken not already in cookies 

  if (document.cookie.match(/kcdtoken/) !== null) {
    // if cookie is already there, then clear
    console.log("cookie is already there")
    document.cookie = "kcdtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
  }
  document.cookie = `kcdtoken=${opentoken};domain=.optum.com;SameSite=Strict`;

  var myHeaders = new Headers();
  myHeaders.append("Cookie", `kcdtoken=${opentoken};domain=.optum.com;SameSite=Strict`);
  myHeaders.append("Access-Control-Allow-Origin", "*");

  var requestOptions = {
    method: "POST",
    credentials: "include" as RequestCredentials,
    mode: "no-cors" as RequestMode,
    headers: myHeaders,
    redirect: "follow" as RequestRedirect,
  };
  var pingEndPoint = `https://${configMap.pingBaseUrl}/as/${sessionId}/resume/as/authorization.ping`;
  require('isomorphic-fetch');
  fetch(
    pingEndPoint,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      window.location.replace("//" + encodeURI(url));
    })
    .catch((error) => console.log("error", error));
}

// Clear everything related to sessions
export function clearSession() {
  document.cookie = "kcdtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
  sessionStorage.clear();
  localStorage.clear();
}